<div>
  <div id="root">
    <app-navigation
      [logoTopSrc]="logoTopSrc"
      [loginUrl]="loginUrl"
      [signupUrl]="signupUrl"
      [filteredLanguages]="filteredLanguages$ | async"
      [popularLanguages]="popularLanguages$ | async"
      [locale]="locale"
      (signedUpPopUp)="managedSignUpPopUp()"
      (scrollPage)="scrollPageToTop()"
      (languageChange)="onLanguageChange()"
    ></app-navigation>

    <div class="content" [class.small-content]="smallHeight" autoscroll ca-compatibility-layer>
      <ng-content></ng-content>
    </div>

    <app-footer [loginUrl]="loginUrl" [signupUrl]="signupUrl" (scrollPage)="scrollPageToTop()"></app-footer>
  </div>
</div>
